import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'rl-core-receipt-content',
    imports: [CommonModule, RouterModule],
    templateUrl: './receipt-lookup-content.component.html',
    styleUrl: './receipt-lookup-content.component.scss'
})
export class ReceiptLookupContentComponent {}
